import { render } from "./member.vue?vue&type=template&id=d40d269a&scoped=true&ts=true"
import script from "./member.vue?vue&type=script&lang=ts"
export * from "./member.vue?vue&type=script&lang=ts"

import "./member.vue?vue&type=style&index=0&id=d40d269a&lang=less&scoped=true"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40d269a"]])

export default __exports__